/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ShapeCircleMOffIcon32Regular = forwardRef('ShapeCircleMOffIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.707 3.293a1 1 0 0 0-1.414 1.414l4.254 4.254A10.955 10.955 0 0 0 5 16c0 6.075 4.925 11 11 11 2.677 0 5.132-.957 7.04-2.547l4.253 4.254a1 1 0 0 0 1.414-1.414l-24-24Zm16.91 19.739L8.969 10.382a9 9 0 0 0 12.65 12.65Z" }),
        React.createElement("path", { d: "M25 16a8.967 8.967 0 0 1-.803 3.722l1.491 1.492A10.952 10.952 0 0 0 27 16c0-6.075-4.925-11-11-11-1.886 0-3.662.475-5.214 1.312l1.492 1.491A9 9 0 0 1 25 16Z" })));
});
